module.exports = __webpack_public_path__ + "b86e18fa561ec18c5d37a17960eeab1d.png";